var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_580_509",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 20,
    height: 20
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12Z",
    fill: "#FA756D"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_580_509)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 19.8673C4 24.28 7.57715 27.8571 11.9898 27.8571C16.4024 27.8571 19.9796 24.28 19.9796 19.8673C19.9796 15.4547 16.4024 14.0969 11.9898 14.0969C7.57715 14.0969 4 15.4547 4 19.8673Z",
    fill: "#B0AFAF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.66333 8.10459C6.66333 10.9238 8.94873 13.2092 11.7679 13.2092C14.5871 13.2092 16.8725 10.9238 16.8725 8.10459C16.8725 5.2854 14.5871 3 11.7679 3C8.94873 3 6.66333 5.2854 6.66333 8.10459Z",
    fill: "#B0AFAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/Profile.1128d12b77991cd66316565115c33256.svg";
export { ForwardRef as ReactComponent };